<template>
  <div class="table-container">
    <el-button type="primary" style="margin-bottom: 15px" @click="addBtn(true, null)">
      添加韩国购物平台分类
    </el-button>
    <!-- <el-select @change="getList()" v-model="queryForm.kor_type" placeholder="请选择">
        <el-option
          v-for="(item , index) in type_list"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select> -->
    <el-table ref="tableSort" v-loading="listLoading" row-key="id" :data="list" element-loading-text="加载中" height="74vh"
      :default-expand-all="false" :tree-props="{ children: 'sub', hasChildren: true }" border>
      <!-- <el-table-column show-overflow-tooltip label="序号" width="120" align="center">
        <template #default="scope">
          {{ scope.$index + 1 }}
        </template>
</el-table-column> -->


      <el-table-column align="center" prop="name" show-overflow-tooltip label="名称"></el-table-column>
      <!-- 商品图片 -->
      <!-- <el-table-column show-overflow-tooltip label="分类图" align="center">
        <template #default="{ row }">
          <el-image :src="row.pic"></el-image>
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="sort" label="排序"></el-table-column>
      <!-- <el-table-column align="center" prop="id" label="ID" min-width="90"></el-table-column> -->
      <el-table-column align="center" prop="add_time" label="添加时间"></el-table-column>
      <!-- <el-table-column fixed="right" align="center" show-overflow-tooltip label="状态">
        <template #default="{ row }">`
          <span v-if="row.status == 0" style="color: green;">显示</span>
          <span v-else style="color: red;">隐藏</span>
        </template>
      </el-table-column> -->
      <el-table-column fixed="right" align="center" show-overflow-tooltip label="操作面板">
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <!-- <el-button v-if="row.isFather" type="text" @click="addChild(true, row)">
            添加子分类
          </el-button> -->
          <el-popconfirm confirm-button-text="确认" cancel-button-text="取消" icon="el-icon-info" icon-color="red"
            title="确认删除此条？" @confirm="del(row)">
            <el-button slot="reference" type="text" style="color: red; margin-left: 5px">
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
      :page-sizes="[20, 40, 60, 100]" :page-size="queryForm.limit" :total="total" @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <!-- 新增/修改弹出层 -->
    <el-dialog :title="is_add ? '添加分类' : '修改分类'" :visible.sync="dialogFormVisible" top="15vh" width="800px"
      @close="close">
      <el-form v-if="dialogFormVisible" ref="form" :model="form" :rules="rules" label-width="auto">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model.trim="form.name" autocomplete="off" placeholder="请输入分类名称" maxlength="20"
            show-word-limit></el-input>
        </el-form-item>
        <!-- <el-form-item label="线路" prop="kor_type">
          <el-select v-model="form.kor_type" placeholder="请选择">
              <el-option
                v-for="(item , index) in type_list"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item> -->
        <!-- <el-form-item v-if="children_row.id" label="父级" prop="name">
          <el-select v-model="parent_id" placeholder="请选择">
            <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">显示</el-radio>
            <el-radio :label="1">隐藏</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="设置">
          <el-radio-group v-model="form.is_cart">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">不可以加入购物车</el-radio>
            <el-radio :label="2">固定减少金额</el-radio>
            <el-radio :label="3">按重量收费</el-radio>
          </el-radio-group>
        </el-form-item> -->
<!-- 
        <el-form-item v-if="form.is_cart == 2" label="固定减少金额" prop="fixed_price">
          <el-input v-model.trim="form.fixed_price" autocomplete="off" placeholder="输入限购金额" maxlength="20"
            show-word-limit></el-input>
        </el-form-item> -->
<!-- 

        <el-form-item label="限购金额" prop="amount_limit">
          <el-input v-model.trim="form.amount_limit" autocomplete="off" placeholder="输入限购金额" maxlength="20"
            show-word-limit></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="未选中图标" prop="pic2">
          <uploadFile :limit="1" :img-list-string="form.pic2" @fileChange="uploadChange($event, 'pic2')" />
        </el-form-item> -->
        <!-- 分类照片 -->
        <!-- <el-form-item label="选中图标" prop="pic">
          <uploadFile :limit="1" :img-list-string="form.pic" @fileChange="uploadChange($event, 'pic')" />
        </el-form-item> -->



        <el-form-item label="排序" prop="sort">
          <el-input v-model.trim="form.sort" autocomplete="off" placeholder="请输入排序" maxlength="20"
            show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  LinkCateList,
  LinkCateDetail,
  LinkCateUpdate,
  LinkCateDel,
  Index_country_list,
} from '@/api/xgcApi'
import uploadFile from '@/components/uploadFile'
export default {
  name: 'Edit',
  components: {
    uploadFile,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: ['blur', 'change'],
          },
        ],
        kor_type: [
          {
            required: true,
            message: '请选择线路',
            trigger: ['blur', 'change'],
          },
        ],
   
        sort: [
          {
            required: true,
            message: '请排序',
            trigger: 'blur',
          },
        ],
      },
      father_row: {}, //父级信息
      children_row: {},
      parent_id: null,
      dialogFormVisible: false, //增加修改弹出
      form: {
        name: '',
        status: 0,
        kor_type: 0,
        sort: '',
        is_cart: 0,
        amount_limit: 0,
        fixed_price: 0
      }, //提交/修改的表单数据
      list: [], //列表数据
      listLoading: false,
      layout: 'total, sizes, prev, pager, next, jumper',
      background: true,
      total: 0,
      is_add: true,
      type_list: [{ value: 0, label: '韩到中' }],
      queryForm: {
        page: 1,
        limit: 20,
        kor_type: 0,
      },
      countryList: [],
    }
  },
  beforeDestroy() { },
  mounted() {
    this.getList()
  },
  methods: {
    getType_list() {
      // 获取线路
      // Index_country_list

      Index_country_list({}).then((res) => {
        this.countryList = res.data
      })
    },
    // 上传图片
    uploadChange(e, type) {
      var strurl = e.join(',')
      strurl = strurl.replace('\\\\', '\/\/')
      strurl = strurl.replace('\\', '\/')
      strurl = strurl.replace('\\', '\/')
      if (type == 'pic') {
        this.form.pic = strurl
      } else {
        this.form.pic2 = strurl
      }

    },
    // 编辑
    handleEdit(row) {
      this.listLoading = true
      this.is_add = false
      if (row.isFather) {
        this.father_row = row
      } else {
        this.children_row = row
        this.parent_id = Number(row.pid)
      }
      LinkCateDetail({
        id: row.id,
      })
        .then((res) => {
          this.form = res.data
          this.listLoading = false
          this.dialogFormVisible = true
        })
        .catch((err) => {
          this.listLoading = false
        })
    },
    submitForm() {
      if (this.form.name == '') {
        this.$message.warning('请输入分类名称')
        return
      }

//       if (this.form.pic == '') {
//         this.$message.warning('请上传照片')
//         return
//       }
// if (this.form.pic2== '') {
//         this.$message.warning('请上传照片')
//         return
//       }
      if (this.form.is_cart == 2 && this.form.fixed_price == 0) {
        this.$message.warning('请输入固定减少运费金额')
        return
      }




      // 提交表单
      var data = {
        name: this.form.name, //名称
        status: this.form.status, //0正常 1关闭
        kor_type: 0,
        pic: this.form.pic, //图片
        pic2: this.form.pic2, //图片
        sort: this.form.sort,
        is_cart: this.form.is_cart, //0正常 1不可以加入购物车 2固定减少金额 3按重量收费
        amount_limit: this.form.amount_limit, //限购金额
        fixed_price: this.form.fixed_price //is_cart等于2的时候填写，固定减少运费金额
      }
      this.listLoading = true
      if (this.is_add) {
        // 新增
        ; (data.pid = this.father_row.id), //上级id
          (data.pid_all = this.father_row.id ? this.father_row.id : ''), //上级id
          LinkCateUpdate(data)
            .then((res) => {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.listLoading = false
              this.dialogFormVisible = false
              this.getList()
            })
            .catch((err) => {
              this.listLoading = false
            })
      } else {
        // 修改
        data.id = this.form.id
        this.listLoading = false
        data.pid = this.parent_id //上级id
        data.pid_all = this.children_row.pid ? this.parent_id : '' //上级id
        LinkCateUpdate(data)
          .then((res) => {
            this.$message({
              type: 'success',
              message: '操作成功',
            })
            this.listLoading = false
            this.dialogFormVisible = false
            this.getList()
          })
          .catch((err) => {
            this.listLoading = false
          })
      }
    },
    addChild(type, row) {
      // 添加子分类
      if (type) {
        // 这个是新增
        this.is_add = true
        this.father_row = row
      } else {
        // 这个是修改
        this.is_add = false
      }
      this.dialogFormVisible = true
    },
    // 添加/修改
    addBtn(type, row) {
      if (type) {
        // 这个是新增
        this.is_add = true
      } else {
        // 这个是修改
        this.is_add = false
      }
      this.dialogFormVisible = true
    },
    // 对话框关闭
    close() {
      this.dialogFormVisible = false
      this.father_row = {}
      this.children_row = {}
      this.form = {}
    },
    del(row) {
      this.listLoading = true
      LinkCateDel({
        id: row.id,
      })
        .then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功',
          })
          this.listLoading = false
          this.getList()
        })
        .catch((err) => {
          this.listLoading = false
        })
    },
    getList() {
      this.listLoading = true
      LinkCateList(this.queryForm)
        .then((res) => {
          this.list = res.data.list
          this.total = this.data.count
          this.listLoading = false
        })
        .catch((err) => {
          this.listLoading = false
        })
    },

    handleCurrentChange(e) {
      this.queryForm.page = e
    },
    handleSizeChange(e) {
      this.queryForm.limit = e
    },
  },
}
</script>

<style>
:deep .right-panel {
  display: flex;
  align-items: center;
}
</style>
